// The ONE way a bill reaches accounts' MYOB: an email to MYOB's document-import
// inbox with the subject its importer keys on, the document attached by the
// sender. 1.0 hardcoded both in ContractorInvoice.aspx.cs (its only "myob"),
// and Karen Sweatman confirmed the office bills go the same road (2026-09-07:
// "same as the link in orders screen, once she has approved she emails it to
// that myob address"). Copied verbatim, not improved, and not configurable:
// whatever address 1.0 held is the correct one (Robert 2026-08-05). Used by
// the Orders tab (contractor invoices) and Office Expenses alike, so the two
// can never drift apart. A mailto cannot attach, so the link's title tells
// the sender to attach the document — exactly as 1.0 worked.
export const MYOB_IMPORT_ADDRESS = "3be4cbaf-0488-4348-b23a-c8c094c563a1@document.myob.com";
export const MYOB_SUBJECT = "MYOB Importer";

export function myobMailtoHref() {
  const s = encodeURIComponent(MYOB_SUBJECT);
  return `mailto:${MYOB_IMPORT_ADDRESS}?subject=${s}&body=${s}`;
}
